(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero-buybox"] && !Shopify.designMode) return;
  try {
    
  function initLpHeroBuybox(section) {
    var thumbs = section.querySelectorAll('[data-lp-hero-thumb]');
    var slides = section.querySelectorAll('[data-lp-hero-slide]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-lp-hero-thumb');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        slides.forEach(function (slide) {
          var isMatch = slide.getAttribute('data-lp-hero-slide') === index;
          slide.hidden = !isMatch;
          slide.classList.toggle('is-active', isMatch);
        });
      });
    });

    var tabBtns = section.querySelectorAll('[data-lp-hero-tab]');
    var tabPanels = section.querySelectorAll('[data-lp-hero-tab-panel]');
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.getAttribute('data-lp-hero-tab');
        tabBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        tabPanels.forEach(function (panel) {
          var isMatch = panel.getAttribute('data-lp-hero-tab-panel') === index;
          panel.hidden = !isMatch;
          panel.classList.toggle('is-active', isMatch);
        });
      });
    });
  }
  document.querySelectorAll('.lp-hero-buybox').forEach(initLpHeroBuybox);
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.lp-hero-buybox');
    if (section) initLpHeroBuybox(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-results-carousel"] && !Shopify.designMode) return;
  try {
    
  function initLpResultsCarousel(section) {
    var track = section.querySelector('[data-lp-results-track]');
    var prev = section.querySelector('.lp-results-carousel__arrow--prev');
    var next = section.querySelector('.lp-results-carousel__arrow--next');
    if (!track || !prev || !next) return;
    var scrollAmount = function () { return track.clientWidth * 0.8; };
    prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
  }
  document.querySelectorAll('.lp-results-carousel').forEach(initLpResultsCarousel);
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.lp-results-carousel');
    if (section) initLpResultsCarousel(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-landing-v1"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* sticky bar */
    var hero = document.querySelector('.lp__hero');
    var sticky = document.getElementById('lp-sticky');
    if (hero && sticky) {
      var obs = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      obs.observe(hero);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-landing-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var nav = document.getElementById('v2-nav');
    var sticky = document.getElementById('v2-sticky');
    var hero = document.querySelector('.v2__hero');
    if (hero && sticky) {
      var obs = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      obs.observe(hero);
    }
    document.querySelectorAll('.v2__nav-link, .v2__nav-cta, .v2__btn--hero, .v2__btn--outline, .v2__btn--sticky').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var href = el.getAttribute('href');
        if (href && href.startsWith('#')) {
          var target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            var offset = nav ? nav.offsetHeight : 0;
            var top = target.getBoundingClientRect().top + window.scrollY - offset - 16;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-landing-v3"] && !Shopify.designMode) return;
  try {
    
  (function () {

    /* ── GALLERY (carousel + thumbnails) ── */
    var track   = document.getElementById('v3-track');
    var thumbsEl = document.getElementById('v3-thumbs');
    var prevBtn = document.getElementById('v3-prev');
    var nextBtn = document.getElementById('v3-next');
    if (track) {
      var slides = track.querySelectorAll('.v3__slide');
      var thumbs = thumbsEl ? thumbsEl.querySelectorAll('.v3__thumb') : [];
      var total  = slides.length;
      var cur    = 0;
      function goTo(n) {
        cur = (n + total) % total;
        track.style.transform = 'translateX(-' + (cur * 100) + '%)';
        thumbs.forEach(function (t, i) {
          t.classList.toggle('is-active', i === cur);
        });
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { goTo(i); });
      });
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(cur - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(cur + 1); });
      if (total <= 1) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
      }
    }

    /* ── QTY PROMO ── */
    var qtyOptions = document.querySelectorAll('[data-qty-option]');
    var qtyInput   = document.querySelector('[data-qty-input]');
    qtyOptions.forEach(function (opt) {
      opt.addEventListener('click', function () {
        qtyOptions.forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        var radio = opt.querySelector('[data-qty-radio]');
        if (radio) radio.checked = true;
        if (qtyInput) qtyInput.value = opt.dataset.qty || 1;
      });
    });

    /* ── COUNTDOWN ── */
    var countdownEl = document.querySelector('[data-countdown]');
    if (countdownEl) {
      var timerEl   = countdownEl.querySelector('[data-countdown-timer]');
      var minutes   = parseInt(countdownEl.dataset.minutes, 10) || 15;
      var remaining = minutes * 60;
      var interval  = setInterval(function () {
        if (remaining <= 0) { clearInterval(interval); return; }
        remaining -= 1;
        var m = Math.floor(remaining / 60);
        var s = remaining % 60;
        if (timerEl) timerEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      }, 1000);
    }

    /* ── TABS ── */
    var tabBtns   = document.querySelectorAll('.v3__tab-btn');
    var tabPanels = document.querySelectorAll('.v3__tab-panel');
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.dataset.tab;
        tabBtns.forEach(function (b)   { b.classList.remove('v3__tab-btn--active'); b.setAttribute('aria-selected', 'false'); });
        tabPanels.forEach(function (p) { p.classList.remove('v3__tab-panel--active'); });
        btn.classList.add('v3__tab-btn--active');
        btn.setAttribute('aria-selected', 'true');
        var panel = document.querySelector('.v3__tab-panel[data-panel="' + target + '"]');
        if (panel) panel.classList.add('v3__tab-panel--active');
      });
    });

    /* ── STICKY BAR ── */
    var hero   = document.querySelector('.v3__hero');
    var sticky = document.getElementById('v3-sticky');
    if (hero && sticky) {
      var obs = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      obs.observe(hero);
    }

    /* ── SMOOTH SCROLL ── */
    document.querySelectorAll('.v3__btn--outline').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var href = el.getAttribute('href');
        if (href && href.startsWith('#')) {
          var target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            var top = target.getBoundingClientRect().top + window.scrollY - 12;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        }
      });
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-landing-v4"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* sticky bar */
    var hero = document.querySelector('.lp__hero');
    var sticky = document.getElementById('lp-sticky');
    if (hero && sticky) {
      var obs = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      obs.observe(hero);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-landing-v5"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var nav = document.getElementById('v5-nav');
    var sticky = document.getElementById('v5-sticky');
    var hero = document.querySelector('.v5__hero');
    if (hero && sticky) {
      var obs = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      obs.observe(hero);
    }
    document.querySelectorAll('.v5__nav-link, .v5__nav-cta, .v5__btn--hero, .v5__btn--outline, .v5__btn--sticky').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var href = el.getAttribute('href');
        if (href && href.startsWith('#')) {
          var target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            var offset = nav ? nav.offsetHeight : 0;
            var top = target.getBoundingClientRect().top + window.scrollY - offset - 16;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
